import EvaluateRules from "../Rules/EvaluateRules";

const ApplyFormStateRules = (formDef, state) => {

    state = state === undefined ? "" : state;

    for (const page of formDef.Pages) {
        page.Visible = true;
        for (const rule of formDef.Rules) {
            if (page.Name === rule.Page) {
                if ( (! state.includes(rule.State)) && rule.Outcome.toLowerCase() === "visible") {
                    page.Visible = false
                }
            }
        }
    }
}

const CalculateStateFromFormStateRules = (page, state, sourceOfClick) => {

    let newState = state.currentState;

    if (page.NextButton !== undefined && page.NextButton.OnClickState !== undefined && page.NextButton.OnClickState.State !== "") {
        state.formDef.data["SourceOfClick"] = sourceOfClick; 
        if ((page.NextButton.OnClickState.Rules === undefined || page.NextButton.OnClickState.Rules === "") ||
            EvaluateRules(page.NextButton.OnClickState.State, page.NextButton.OnClickState.Rules, state.formDef.data)) {
            if (!newState.includes(page.NextButton.OnClickState.State)) {
                newState = newState === "" ? page.NextButton.OnClickState.State : newState + "," + page.NextButton.OnClickState.State;
            }
        } else {

            if (newState !== "") {
                let stateArray = newState.split(",");
                stateArray = stateArray.filter((item) => item !== page.NextButton.OnClickState.State);
                newState = stateArray.toString();
            }
        };
        delete state.formDef.data.SourceOfClick; 
    }

    return newState;
}

const EvaluateFormStateRules = (nextButton, data) => {
    let returnValue = true;
    if ((nextButton !== undefined && nextButton.OnClickState !== undefined && nextButton.OnClickState.Rules !== undefined)) {
        const rules = nextButton.OnClickState.Rules.filter((f) => f.Field.toLowerCase() !== "sourceofclick");
        returnValue = EvaluateRules(nextButton.OnClickState.State, rules, data);
    }
    return returnValue;
}

const WillThisBeTheLastPage = (state, rules, pages, currentPageName) => {

    const matchingRules = rules === undefined ? 0 : rules.filter(r => r.State.toLowerCase() === state.toLowerCase());
    let finalPage = matchingRules.length === 0;

    let allPagesInRules = true
    let currentPageFound = false;
    if (finalPage) {
        for (const page of pages) {
            if (currentPageFound) {
                let matchingPage = rules.filter(r => r.Page.toLowerCase() === page.Name.toLowerCase());
                if (matchingPage.length === 0) {
                    allPagesInRules = false;
                }
            } else {
                currentPageFound = currentPageName == page.Name;
            }
        }
        finalPage = allPagesInRules;
    }

    return finalPage;
}

export default ApplyFormStateRules;

export { CalculateStateFromFormStateRules, EvaluateFormStateRules, WillThisBeTheLastPage }
